import {
    CREATE_PRINTING_DC_DETAILS_FAILURE_DK,
    CREATE_PRINTING_DC_DETAILS_REQUEST_DK,
    CREATE_PRINTING_DC_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_PRINTING_DC_DETAILS_DK,
    DELETE_PRINTING_DC_DETAILS_FAILURE_DK,
    DELETE_PRINTING_DC_DETAILS_REQUEST_DK,
    DELETE_PRINTING_DC_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_PRINTING_DC_DETAILS_FAILURE_DK,
    FETCH_SINGLE_PRINTING_DC_DETAILS_REQUEST_DK,
    FETCH_SINGLE_PRINTING_DC_DETAILS_SUCCESS_DK,
    FETCH_PRINTING_DC_DETAILS_FAILURE_DK,
    FETCH_PRINTING_DC_DETAILS_REQUEST_DK,
    FETCH_PRINTING_DC_DETAILS_SUCCESS_DK,
    PRINTING_DC_DETAILS_USERFORM_RESET_DK,
    UPDATE_PRINTING_DC_DETAILS_FAILURE_DK,
    UPDATE_PRINTING_DC_DETAILS_REQUEST_DK,
    UPDATE_PRINTING_DC_DETAILS_SUCCESS_DK,
    FETCH_PRINTING_DC_DETAILS_BY_ID_REQUEST_DK,
    FETCH_PRINTING_DC_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_PRINTING_DC_DETAILS_DC_NO_REQUEST_DK_DK,
    FETCH_PRINTING_DC_DETAILS_DC_NO_SUCCESS_DK_DK,
    FETCH_PRINTING_DC_DETAILS_DC_NO_FAILURE_DK_DK,
    FETCH_GRN_NO_BY_PRINTING_DC_NO_REQUEST_DK_DK,
    FETCH_GRN_NO_BY_PRINTING_DC_NO_SUCCESS_DK_DK,
    FETCH_GRN_NO_BY_PRINTING_DC_NO_FAILURE_DK_DK,
    FETCH_PRINTING_DC_DETAILS_PROGRAM_REQUEST_DK,
    FETCH_PRINTING_DC_DETAILS_PROGRAM_SUCCESS_DK,
    FETCH_PRINTING_DC_DETAILS_PROGRAM_FAILURE_DK
} from './printingDCDetails.actionsType';

export const PRINTING_DC_DETAILS_DK = 'printingDcDetailsDK';

let initialState = {
    loading: false,
    printingDCDetailsById: [],
    printingDCDetails: [],
    printingDCDetailsDcNo: [],
    grnNoByPrintingDcNo: [],
    printingDCDetailsProgram: [],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedPrintingDCDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let printingDCDetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_PRINTING_DC_DETAILS_REQUEST_DK:
        case FETCH_PRINTING_DC_DETAILS_PROGRAM_REQUEST_DK:
        case FETCH_GRN_NO_BY_PRINTING_DC_NO_REQUEST_DK_DK:
        case FETCH_PRINTING_DC_DETAILS_DC_NO_REQUEST_DK_DK:
        case FETCH_PRINTING_DC_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_PRINTING_DC_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_PRINTING_DC_DETAILS_REQUEST_DK:
        case UPDATE_PRINTING_DC_DETAILS_REQUEST_DK:
        case DELETE_PRINTING_DC_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PRINTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDCDetails: updatePayload
            };
        case FETCH_PRINTING_DC_DETAILS_PROGRAM_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDCDetailsProgram: updatePayload?.Program
            };
        case FETCH_PRINTING_DC_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDCDetailsById: updatePayload
            };
        case FETCH_GRN_NO_BY_PRINTING_DC_NO_SUCCESS_DK_DK:
            return {
                ...state,
                loading: false,
                grnNoByPrintingDcNo: updatePayload?.Inward
            };
        case CREATE_PRINTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_PRINTING_DC_DETAILS_DC_NO_SUCCESS_DK_DK:
            return {
                ...state,
                loading: false,
                printingDCDetailsDcNo: updatePayload?.PRD
            };
        case FETCH_SINGLE_PRINTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedPrintingDCDetails: updatePayload[0],
                userform: updatePayload[0]
            };
        case UPDATE_PRINTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedPrintingDCDetails: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case DELETE_PRINTING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedPrintingDCDetails: {}
            };

        case FETCH_PRINTING_DC_DETAILS_FAILURE_DK:
        case FETCH_PRINTING_DC_DETAILS_PROGRAM_FAILURE_DK:
        case FETCH_PRINTING_DC_DETAILS_DC_NO_FAILURE_DK_DK:
        case FETCH_GRN_NO_BY_PRINTING_DC_NO_FAILURE_DK_DK:
        case FETCH_SINGLE_PRINTING_DC_DETAILS_FAILURE_DK:
        case CREATE_PRINTING_DC_DETAILS_FAILURE_DK:
        case UPDATE_PRINTING_DC_DETAILS_FAILURE_DK:
        case DELETE_PRINTING_DC_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_PRINTING_DC_DETAILS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case PRINTING_DC_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedPrintingDCDetails: {}
            };
        default:
            return state;
    }
};
